module.exports = __webpack_public_path__ + "static/img/governance1.5f666693.png";